export enum TestUser {
    AGNI = "AGNI", // manager
    ARYA = "ARYA", // employee 1
    TEJAS = "TEJAS", // employee 2
    NYX = "NYX", // employee 2
    HYPER = "HYPER",
    Melhem = "Melhem", // employee

    // swapping test emp
    // manager = EDUARD
    // emp = DANIEL, DAVID
    PACE_DANIEL = "PACE_DANIEL",
    PACE_DAVID = "PACE_DAVID",
    PACE_EDUARD = "PACE_EDUARD",
    PACE_YURI = "PACE_YURI",
    PACE_MARKO = "PACE_MARKO",
    PACE_MARTIN = "PACE_MARTIN",
    PACE_MICHAIL = "PACE_MICHAIL",
    PACE_MILOS = "PACE_MILOS",
    PACE_NIKOLA = "PACE_NIKOLA",
    PACE_SHAWN = "PACE_SHAWN",
    // swapping test emp


    // nextgen
    NGW_OFC = "NGW_OFC",
}

export const TestTokenProvider = (user: TestUser) => {
    //
    switch (user) {
        case TestUser.Melhem:
            return "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJsb2dnZWRpbl9pZCI6IjU1NzU0IiwidXNlcl9hY2NvdW50X2lkIjoiMTc0NDAyMTc4NSJ9.WvULLz1P4gIHYSxSQHivkiHvyB0spM-M1g-PkXD27do";
        case TestUser.AGNI:
            return "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VyX2FjY291bnRfaWQiOiIxNzQ0MDIxNzg1IiwibG9nZ2VkaW5faWQiOiI1NTc1MyJ9.vZpA80mHe7t9hItAMwLZ1DVTnuiRyssZYAQDWHUkUpE";

        case TestUser.TEJAS:
            return "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VyX2FjY291bnRfaWQiOiIxNzM1MjA4MDE5IiwibG9nZ2VkaW5faWQiOiI1NDg4NCJ9.0KYJnYE-zDltq0gW5389b6jrIwuoW9M-XN5I4Z3jynE";

        case TestUser.ARYA:
            return "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VyX2FjY291bnRfaWQiOiIxNjY3Mjg2ODAzIiwibG9nZ2VkaW5faWQiOiI1NDgzMSJ9.YW_H43wlrI4M0xzsZFfrUYjrrpJ_2IihX2k5n3biziw";

        case TestUser.NYX:
            return "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJsb2dnZWRpbl9pZCI6IjU1NDg5IiwidXNlcl9hY2NvdW50X2lkIjoiMTczNTIwODAxOSJ9.RyyN8WbNi9SLoWKaR_x3cQZmkx7CwZkPv27XFp0xvMs";

        case TestUser.HYPER:
            return "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJsb2dnZWRpbl9pZCI6IjU1NDkwIiwidXNlcl9hY2NvdW50X2lkIjoiMTczNTIwODAxOSJ9.32gjSxXIVoRWNMHCbk9tDQdUACmZdNgKu0abTBsq6Ac";

        case TestUser.PACE_DANIEL:
            return "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJsb2dnZWRpbl9pZCI6IjUzNjQ2IiwidXNlcl9hY2NvdW50X2lkIjoiMTcyMDA4NTQ0MCJ9.O0VyjBGQw-4g_ICDx1ZysJwc07T5yRGJWQx1SnxwvuI";

        case TestUser.PACE_DAVID:
            return "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJsb2dnZWRpbl9pZCI6IjUzNjQ3IiwidXNlcl9hY2NvdW50X2lkIjoiMTcyMDA4NTQ0MCJ9.UnBmU4tdHj7i5ItLnfQ4hYN7ZMWnvdX-Ti88Tiqgp-0";

        case TestUser.PACE_EDUARD:
            return "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJsb2dnZWRpbl9pZCI6IjUzNjQyIiwidXNlcl9hY2NvdW50X2lkIjoiMTcyMDA4NTQ0MCJ9.8_JyMHR1dsilGjCljLrgPmLEvpEkJ8Gl9VReqi50DK0";

        case TestUser.PACE_YURI:
            return "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJsb2dnZWRpbl9pZCI6IjU0NjkzIiwidXNlcl9hY2NvdW50X2lkIjoiMTcyMDA4NTQ0MCJ9.8GvoZzHq7_iVkxnZOJn2lsJPYHUpsmnFjYPh0Hi0W44";

        case TestUser.PACE_MARKO:
            return "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJsb2dnZWRpbl9pZCI6IjUzNjQ0IiwidXNlcl9hY2NvdW50X2lkIjoiMTcyMDA4NTQ0MCJ9.pP_6AOFQV0FkOyH7f3VZYAm92qSONpmegjb0t8PLuY8";

        case TestUser.PACE_MARTIN:
            return "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJsb2dnZWRpbl9pZCI6IjUzNjQzIiwidXNlcl9hY2NvdW50X2lkIjoiMTcyMDA4NTQ0MCJ9.OJ_sf7n9HauSMzM4uoRYDmfKLVdn4eIT4TZmQz8CL_4";

        case TestUser.PACE_MICHAIL:
            return "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJsb2dnZWRpbl9pZCI6IjU0NzE3IiwidXNlcl9hY2NvdW50X2lkIjoiMTcyMDA4NTQ0MCJ9.JbAOBZnjcclpKbNYKi5wphqko7yDOKOYB8wIGt6yY-A";

        case TestUser.PACE_MILOS:
            return "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJsb2dnZWRpbl9pZCI6IjU0NzE1IiwidXNlcl9hY2NvdW50X2lkIjoiMTcyMDA4NTQ0MCJ9.g1dr_z3d0D2WpTh8RS_-V2RsQNpNy5oDZItAIgQslzs";

        case TestUser.PACE_NIKOLA:
            return "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJsb2dnZWRpbl9pZCI6IjU0NzAyIiwidXNlcl9hY2NvdW50X2lkIjoiMTcyMDA4NTQ0MCJ9.1Vw2-ckZH0kqlfjeNvzA9UgXUndN0aHOJgWV0T7WvOI";
    
        case TestUser.PACE_SHAWN:
            return "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJsb2dnZWRpbl9pZCI6IjU0NzA1IiwidXNlcl9hY2NvdW50X2lkIjoiMTcyMDA4NTQ0MCJ9.OY82-5171KybxIjGPuSni7Vwjqu1PkjOLuwWwdjwkw4";
        
        case TestUser.NGW_OFC:
            return "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VyX2FjY291bnRfaWQiOiIxNzMxMzg5NzE5IiwibG9nZ2VkaW5faWQiOiIxNzMxMzg5NzE5In0.MJULPsme2RPe72NMEmTh2BKoh5-QrFI0dmtMD0Yw1GI";
        }
};

export const getRandomOptionalValue = <T>(value: T): T | null | undefined => {
    const randomValue = Math.random();

    if (randomValue < 0.33) {
        return undefined;
    } else if (randomValue < 0.66) {
        return null;
    } else {
        return value;
    }
};
